module.exports = __webpack_public_path__ + "img/product-attr01.2249444a.png";